import PropTypes from "prop-types";
import React, { useEffect } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { useHistory } from "react-router-dom";
import { useForm } from "../../../hooks";
import eventTypeConstant from "../../../util/eventTypeConstant";
import FieldTitleWithInfoIcon from "../fieldTitle";
import SelectBox from "../selectBox";

const CreateEventType = ( { onSave, isEditEventType, eventTypeDetail } ) => {
  const history = useHistory();
  const { values, errors, isError, handleChange, showAllErrorMessage } =
    useForm(
      {
        eventName: "",
        units: eventTypeConstant.UNITS[ 0 ],
        description: "",
      },
      {
        eventName: false,
        description: false,
      }
    );

  useEffect( () => {
    if( isEditEventType && eventTypeDetail ) {
      handleChange( "eventName", eventTypeDetail.eventName );
      handleChange( "units", eventTypeDetail.units );
      handleChange( "description", eventTypeDetail.description );
    }
  }, [ eventTypeDetail ] );

  const handleInputChange = ( e ) => {
    const { name, value } = e.target;

    handleChange( name, value );
  };

  const handleSelectChange = ( selectedValue ) => {
    handleChange( "units", selectedValue );
  };

  const handleSave = () => {
    showAllErrorMessage();

    if( !isError ) {
      onSave( values );
    }
  };

  return (
    <>
      <div className='main-wrapper'>
        <div className='main-right-wrapper'>
          <div className='page-head-wrapper'>
            <h4 className='page-heading'>
              {isEditEventType ? "Edit Event Type" : "Add Event Type"}
            </h4>
            <div className='page-head-right'>
              <Button
                variant='outline-secondary mr-4'
                onClick={() => history.goBack()}
              >
                Cancel
              </Button>
              {( eventTypeDetail?.isActive || !isEditEventType ) && ( <Button variant='primary' onClick={handleSave}>
                {isEditEventType ? "Update" : "Save"}
              </Button> )}
            </div>
          </div>
          <div className='page-inner-box profile-steps-box'>
            <Form>
              <Row>
                <Col sm={6}>
                  <Form.Group>
                    <FieldTitleWithInfoIcon title='Event Type Name' description='The name must be unique across all your games. Only you will be able to use the event type.' />
                    <Form.Control
                      type='text'
                      placeholder='Enter Event Name'
                      name='eventName'
                      onChange={handleInputChange}
                      value={values.eventName}
                      maxLength={50}
                      data-testid='eventName'
                    />
                    <div className='invalid-feedback d-block'>
                      {errors.eventName}
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Units</Form.Label>
                    <SelectBox
                      options={eventTypeConstant.UNITS}
                      value={values.units}
                      onChange={handleSelectChange}
                    />
                  </Form.Group>
                </Col>
                <Col sm={12}>
                  <Form.Group>
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as='textarea'
                      placeholder='Write Description'
                      name='description'
                      onChange={handleInputChange}
                      value={values.description}
                      maxLength={500}
                      data-testid='description'
                    />
                    <div className='invalid-feedback d-block'>
                      {errors.description}
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

CreateEventType.propTypes = {
  onSave: PropTypes.func,
  isEditEventType: PropTypes.string,
  eventTypeDetail: PropTypes.object,
};

export default CreateEventType;
